export default __webpack_public_path__ + "static/media/95.0005a9be.png";